import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Col, Row, Space, Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useDashboardCurrency } from 'views/Dashboard/ImplementData/hooks/useCurrency';
import { currencyDisplayWithUnit, numDisplay } from 'views/Dashboard/ImplementData/utils';
import bg1 from './assets/1.svg';
import bg2 from './assets/2.svg';
import bg3 from './assets/3.svg';
import bg4 from './assets/4.svg';
import bg5 from './assets/5.svg';
import { useDashboardFilterContext, useDashboardPlatformTips } from '../Filter/useFilter';

const Container = styled(Row)`
  display: flex;
  border-radius: 4px;
  width: 100%;
  height: 95px;
  background-color: #ffffff;
`;
const Item = styled(Col)<{ bg: string }>`
  flex: 1 0 0;
  background-image: ${({ bg }) => `url('${bg}')`};
  background-position: right bottom;
  background-size: 56px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  border-right: 1px solid #f5f5f5;
  color: #515359;
  padding: 0 24px;

  &:last-child {
    border-right: none;
  }
  .title {
    font-size: 14px;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
    /* width: 100%; */
    overflow: hidden;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .anticon {
      flex: none;
      width: 14px;
      margin-left: 4px;
    }
  }
  .num {
    font-size: 20px;
  }
`;

interface Props {
  value?: Dashboard.OrderOverviewInner;
}

const Total = (props: Props) => {
  const { value } = props;
  const { t } = useTranslate();
  const { currency } = useDashboardCurrency();
  const { hasTokopedia } = useDashboardFilterContext();

  const {
    下单总量tips,
    下单总金额tips,
    复购订单总量tips,
    platformInfo: { isOnlyMercadoOrOnlyTokopedia },
  } = useDashboardPlatformTips();

  return (
    <Container>
      {!isOnlyMercadoOrOnlyTokopedia && (
        <Item bg={bg1}>
          <div className="title">
            <span>{t('ViewDashboard.订单总量')}</span>
            {下单总量tips && (
              <Tooltip title={下单总量tips}>
                <QuestionCircleOutlined />
              </Tooltip>
            )}
          </div>
          <div className="num">{numDisplay(value?.订单总量)}</div>
        </Item>
      )}
      {!isOnlyMercadoOrOnlyTokopedia && (
        <Item bg={bg2}>
          <div className="title">
            <span>{t('ViewDashboard.订单总额', { unit: currency?.shorthand ?? 'CNY' })}</span>
            {下单总金额tips && (
              <Tooltip title={下单总金额tips}>
                <QuestionCircleOutlined />
              </Tooltip>
            )}
          </div>
          <Space className="num" size={4}>
            {currencyDisplayWithUnit(currency?.shorthand, value?.订单总额)}
          </Space>
        </Item>
      )}
      <Item bg={bg3}>
        <div className="title">
          <span>{t('ViewDashboard.付款订单量')}</span>
          <Tooltip title={t('ViewDashboard.付款订单量tooltip')}>
            <QuestionCircleOutlined />
          </Tooltip>
        </div>
        <div className="num">{numDisplay(value?.付款订单量)}</div>
      </Item>
      {isOnlyMercadoOrOnlyTokopedia && (
        <Item bg={bg1}>
          <div className="title">
            <span>
              {t('付款订单总金额')}({currency?.shorthand ?? 'CNY'})
            </span>
          </div>
          <Space className="num" size={4}>
            {currencyDisplayWithUnit(currency?.shorthand, value?.订单总额)}
          </Space>
        </Item>
      )}
      <Item bg={bg4}>
        <div className="title">
          <span>{t('aide.弃单总量')}</span>
          <Tooltip
            title={
              <div>
                {t('ViewDashboard.退单总量tooltip')}
                {hasTokopedia && <div>{t('dashboard_tokopedia_tips1')}</div>}
              </div>
            }
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </div>
        <div className="num">{numDisplay(value?.退单总量)}</div>
      </Item>
      <Item bg={bg5}>
        <div className="title">
          <span> {t('ViewDashboard.复购订单总量')}</span>
          <Tooltip
            title={
              复购订单总量tips?.replaceAll('\\n', '\n') || t('ViewDashboard.复购订单总量tooltip')
            }
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </div>
        <div className="num">{numDisplay(value?.复购订单总量)}</div>
      </Item>
    </Container>
  );
};

export default Total;
